import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';
import WinPopup from '../../../components/common/winPopup';
import { winPopupStore } from '../../../store/winPopupStore';

const WinPopupWrapper = observer(() => {
  const { isOpenWinPopup } = winPopupStore;
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 270 : 720,
        y: isMobile() ? 480 : 405,
      },
    };
  }, []);

  if (!isOpenWinPopup) {
    return null;
  }
  return <WinPopup containerConfig={containerConfig} />;
});

export default WinPopupWrapper;
